"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AddOrUpdateCreditCardModel () {
        return AddOrUpdateCreditCardModel;
    },
    get BillingSettingsModel () {
        return BillingSettingsModel;
    },
    get CalculateProratedTotalModel () {
        return CalculateProratedTotalModel;
    },
    get CancelCreditCardSetupIntentModel () {
        return CancelCreditCardSetupIntentModel;
    },
    get CreateAddSeatsPaymentIntentModel () {
        return CreateAddSeatsPaymentIntentModel;
    },
    get CreateCreditCardSetupIntentModel () {
        return CreateCreditCardSetupIntentModel;
    }
});
const _zod = require("zod");
const _company = require("./company");
const BillingSettingsModel = _zod.z.object({
    company: _company.CompanyBillingSettingsModel,
    card: _zod.z.custom(),
    charges: _zod.z.array(_zod.z.custom())
});
const CalculateProratedTotalModel = _zod.z.object({
    formattedBillingPrice: _zod.z.string(),
    formattedProratedPrice: _zod.z.string(),
    formattedTotalTax: _zod.z.string(),
    formattedTotalPrice: _zod.z.string(),
    usersToAdd: _zod.z.number()
});
const CreateAddSeatsPaymentIntentModel = _zod.z.object({
    paymentIntent: _zod.z.custom().optional(),
    message: _zod.z.string()
});
const CreateCreditCardSetupIntentModel = _zod.z.object({
    setupIntent: _zod.z.custom()
});
const CancelCreditCardSetupIntentModel = _zod.z.object({
    setupIntent: _zod.z.custom()
});
const AddOrUpdateCreditCardModel = _zod.z.object({
    message: _zod.z.string().optional(),
    errors: _zod.z.array(_zod.z.string()).optional()
});
